import block from './block';


function addToCart(){
    $('body').on('click', '[data-add-to-cart]', function (e){
        e.preventDefault();
        const product_id = $('[name=add-to-cart]').val('product_id');
        const ajaxData = {
            action: 'ajax_add_to_cart',
            product_id: product_id,
            quantity: $('.product-page [data-quantity-input]').val(),
        };

        $.post(settings.ajax_url, ajaxData)
            .done((response) => {
                response = JSON.parse(response);
                if (response.added !== 0) {
                    $('[data-cart-dropdown]').html(response.newCart);
                    $('[data-cart-shipping-row]').html(response.newShipping);
                    $('[data-product_shipping_additional_info]').html(response.product_shipping_additional_info);
                    $('.header-icon-count').html(response.newAmountOfItems);
                } else {
                    console.log('error during added to cart');
                }
                block.unblockAll('[data-ajax-add-to-cart-product]');
            });
    });
}


function getNewProductsAmountInCart(){
    let data = [];

    $('header [data-quantity-input]').each(function (){
        let test = [[$(this).data('cart_item_key'),
            $(this).val()]];
        data = [...data, ...test];
    });

    return data;
}

function removeFromCart(){
    $('header').on('click', '[data-remove-from-cart]', function (e){
        $('[data-cart-dropdown]').append('<div class="loader-wrapper"><span class="loader"></span></div>');
        e.preventDefault();
        let ajaxData = {
            action: 'ajax_remove_from_cart',
            key: $(this).data('cart_item_key')
        };
        if($('body').hasClass('single-product')) {
            ajaxData.currentProduct = $('.product-page__actions .single_add_to_cart_button').data('product-id');
        }
        $.post(settings.ajax_url, ajaxData)
            .done((response) => {
                response = JSON.parse(response);
                if (response.removed) {

                    $(this).parent().parent().slideUp('300').remove();
                    $('[data-cart-dropdown]').html(response.newCart);
                    $('[data-cart-shipping-row]').html(response.newShipping);
                    $('.product-page__actions .variations.variation-options').html(response.newActions);
                    $('[data-product_shipping_additional_info]').html(response.product_shipping_additional_info);
                    $('.header-icon__count--cart').html(response.newAmountOfItems);
                    $('.cart-summary--subtotal').html(response.subtotal);
                    $('[data-cart-dropdown] .loader-wrapper').remove();
                }
            });
    });
}

function changeCartQuantity(btn, quantity){
    $('[data-cart-dropdown]').append('<div class="loader-wrapper"><span class="loader"></span></div>');
    let product = '';
    block.blockAll('[data-ajax-add-to-cart-product]');
    if (btn) {
        product = btn.dataset.productId;
    }
    let ajaxData = {
        action: 'ajax_update_order_total',
        data: getNewProductsAmountInCart(),
        product: product,
        quantity: quantity
    };
    if($('body').hasClass('single-product')) {
        ajaxData.currentProduct = $('.product-page__actions .single_add_to_cart_button').data('product-id');
    }

    $.post(settings.ajax_url, ajaxData)
        .done((response) => {
            response = JSON.parse(response);
            if (response.added) {
                $('[data-cart-dropdown]').html(response.newCart);
                $('[data-cart-shipping-row]').html(response.newShipping);
                $('[data-product_shipping_additional_info]').html(response.product_shipping_additional_info);
                $('.header-icon__count--cart').html(response.newAmountOfItems);
                $('.product-page__actions .variations.variation-options').html(response.newActions);
                $(btn).find('[data-show-when-added]').text('Dodane!');
                $(btn).find('[data-show-when-added]').css('opacity', 1);
                setTimeout(function (){
                    $('[data-ajax-add-to-cart-product]').find('[data-show-when-added]').css('opacity', 0);
                }, 1500);
            } else {
                $(btn).find('[data-show-when-added]').text('Brak w magazynie!');
                $(btn).find('[data-show-when-added]').css('background-color', 'red');
                $(btn).find('[data-show-when-added]').css('opacity', 1);
                setTimeout(function (){
                    $('[data-ajax-add-to-cart-product]').find('[data-show-when-added]').css('opacity', 0);
                }, 1500);
            }
            block.unblockAll('[data-ajax-add-to-cart-product]');
            // block.unblockAll('[data-remove-from-cart]');
            $('[data-cart-dropdown] .loader-wrapper').remove();
        });

}

function updateCartPageOnChange() {
    $('body').on('click','[data-quantity], [data-product_sku]', function () {
        setTimeout(function (){
            let ajaxData = {
                action: 'update_cart_info_after_cart_change',
            };
            $.post(settings.ajax_url, ajaxData)
                .done((response) => {
                    response = JSON.parse(response);
                    $('[data-cart-shipping-row]').html(response.newShipping);
                    $('.header-icon__count--cart').html(response.newAmountOfItems);
                });

        }, 500);
        console.log('test');
    });
}

function init(){

    removeFromCart();

    //addToCart();
}

export default {init, addToCart, removeFromCart, changeCartQuantity, updateCartPageOnChange};



// WEBPACK FOOTER //
// ./src/scripts/cart-functions.js